import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getMediaUrl } from '../utils/mediaUrl';

/**
 * Full-screen shell for Bazzef Messenger. The conversation list and thread
 * are the existing Messages page; this only adds sign-out, reached from the
 * avatar that Messages already renders.
 */
const MessengerLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [accountOpen, setAccountOpen] = useState(false);

  const handleLogout = async () => {
    setAccountOpen(false);
    await logout();
    navigate('/login', { replace: true });
  };

  const initial = (user?.username || user?.handle || 'U').charAt(0).toUpperCase();
  const picture = user?.profilePicture || user?.profile_picture;

  return (
    <div className="h-[100dvh] max-h-[100dvh] overflow-hidden flex flex-col bg-white dark:bg-black">
      <div className="flex-1 flex flex-col min-h-0 min-w-0">
        <Outlet
          context={{
            hideMobileNav: true,
            setHideMobileNav: () => {},
            setDrawerOpen: setAccountOpen,
          }}
        />
      </div>

      {accountOpen && (
        <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center">
          <button
            type="button"
            aria-label="Close"
            className="absolute inset-0 bg-black/40"
            onClick={() => setAccountOpen(false)}
          />
          <div
            role="dialog"
            aria-label="Account"
            className="relative w-full sm:max-w-sm bg-white dark:bg-zinc-900 rounded-t-3xl sm:rounded-3xl border border-zinc-200 dark:border-zinc-800 shadow-xl px-5 pt-5 pb-[calc(1.25rem+env(safe-area-inset-bottom))]"
          >
            <div className="flex items-center gap-3 mb-4">
              {picture ? (
                <img
                  src={getMediaUrl(picture)}
                  alt=""
                  className="w-12 h-12 rounded-full object-cover"
                />
              ) : (
                <div className="w-12 h-12 rounded-full bg-indigo-500 text-white flex items-center justify-center font-bold">
                  {initial}
                </div>
              )}
              <div className="min-w-0">
                <div className="font-semibold text-zinc-900 dark:text-zinc-100 truncate">
                  {user?.username || 'Bazzef'}
                </div>
                {user?.handle && (
                  <div className="text-sm text-zinc-500 truncate">@{String(user.handle).replace(/^@+/, '')}</div>
                )}
                <div className="text-xs text-zinc-400 mt-0.5">Bazzef account</div>
              </div>
            </div>
            <button
              type="button"
              onClick={handleLogout}
              className="w-full py-2.5 rounded-xl text-sm font-semibold text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-950/40"
            >
              Sign out
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MessengerLayout;
